import { render } from "./vdvcfrp.vue?vue&type=template&id=639f0a39&scoped=true"
import script from "./vdvcfrp.vue?vue&type=script&lang=js"
export * from "./vdvcfrp.vue?vue&type=script&lang=js"

import "./vdvcfrp.vue?vue&type=style&index=0&id=639f0a39&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639f0a39"]])

export default __exports__